import
{
    SystemType,
} from "@ews/react-data";

import style from "./SystemIcons.module.scss";
//const Capitalize = (s: string) => `${s.charAt(0).toUpperCase()}${s.substring(1).toLowerCase()}`;

export const SystemTypeIcon: React.FC<{ type: SystemType, width?: string, height?: string; }> = ({ type, width, height }) =>
{
    return <div className={style.iconContainer}>
        <img width={width} height={height} src={`assets/img/system_${type}.png`} alt={`System ${type}`} />
    </div>;
};


